/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyRefundBills } from 'app/entities/pharmacy-refund-bill/pharmacy-refund-bill.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-refund-payment.reducer';

export const PharmacyRefundPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyRefundBills = useAppSelector(state => state.pharmacyRefundBill.entities);
  const pharmacyRefundPaymentEntity = useAppSelector(state => state.pharmacyRefundPayment.entity);
  const loading = useAppSelector(state => state.pharmacyRefundPayment.loading);
  const updating = useAppSelector(state => state.pharmacyRefundPayment.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyRefundPayment.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-refund-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyRefundBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.voidedDate !== undefined && typeof values.voidedDate !== 'number') {
      values.voidedDate = Number(values.voidedDate);
    }

    const entity = {
      ...pharmacyRefundPaymentEntity,
      ...values,
      refundBill: pharmacyRefundBills.find(it => it.id.toString() === values.refundBill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyRefundPaymentEntity,
          refundBill: pharmacyRefundPaymentEntity?.refundBill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyRefundPayment.home.createOrEditLabel" data-cy="PharmacyRefundPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.home.createOrEditLabel">
              Create or edit a PharmacyRefundPayment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-refund-payment-id"
                  label={translate('tinyMedicRestApp.pharmacyRefundPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.paymentMethod')}
                id="pharmacy-refund-payment-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.transactionDetails')}
                id="pharmacy-refund-payment-transactionDetails"
                name="transactionDetails"
                data-cy="transactionDetails"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.paidAmount')}
                id="pharmacy-refund-payment-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.active')}
                id="pharmacy-refund-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.cursor')}
                id="pharmacy-refund-payment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.timestampentry')}
                id="pharmacy-refund-payment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.microSec')}
                id="pharmacy-refund-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.lastupdated')}
                id="pharmacy-refund-payment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.forCredit')}
                id="pharmacy-refund-payment-forCredit"
                name="forCredit"
                data-cy="forCredit"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.voided')}
                id="pharmacy-refund-payment-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.voidedReason')}
                id="pharmacy-refund-payment-voidedReason"
                name="voidedReason"
                data-cy="voidedReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.voidedDate')}
                id="pharmacy-refund-payment-voidedDate"
                name="voidedDate"
                data-cy="voidedDate"
                type="text"
              />
              <ValidatedField
                id="pharmacy-refund-payment-refundBill"
                name="refundBill"
                data-cy="refundBill"
                label={translate('tinyMedicRestApp.pharmacyRefundPayment.refundBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundBills
                  ? pharmacyRefundBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-refund-payment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyRefundPaymentUpdate;
